"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentClient = void 0;

var Interfaces_1 = require("./Interfaces");

var Legacy_1 = require("./Legacy");

var Session_1 = require("./Session");

var BillingContact_1 = require("./BillingContact");

var BillingMethods_1 = require("./BillingMethods");

var BillingMethods_2 = require("./Legacy/BillingMethods");

var Errors_1 = require("./Errors");

var PaymentErrorHandler_1 = require("./Session/PaymentErrorHandler"); // Load Vendor Modules


var Configs_1 = require("./Configs");

var PaymentClient =
/** @class */
function () {
  function PaymentClient(init) {
    if (init === void 0) {
      init = {};
    }

    this.paymentMethod = Interfaces_1.PaymentMethod.notPresent;
    this.env = init.env || Interfaces_1.Env.prod;
    Configs_1.VendorModulesConfig.loadVendorModulesFiles();
  }

  PaymentClient.prototype.processPayment = function () {
    return __awaiter(this, void 0, void 0, function () {
      var paymentLegacyProcessor, e_1, errorHandler, _a, e_2, errorHandler, e_3, errorHandler;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!this.session) {
              throw new Errors_1.PaymentValidationError("Session Information is not present", Interfaces_1.PaymentErrorShortCodes.missing_session);
            }

            if (!this.billingContactInfo) {
              throw new Errors_1.PaymentValidationError("Billing Contact Information is not present", Interfaces_1.PaymentErrorShortCodes.missing_billing_contact);
            }

            if (!Legacy_1.PaymentLegacyProcessor.isLegacyRequest(this.session)) return [3
            /*break*/
            , 4];

            if (!this.sessionData) {
              throw new Errors_1.PaymentValidationError("Session Data Information is not present", Interfaces_1.PaymentErrorShortCodes.missing_session_data, {
                code: "BG-2222"
              });
            }

            paymentLegacyProcessor = new Legacy_1.PaymentLegacyProcessor(this.env, this.session.paymentCommunicator.sessionId, this.sessionData, this.billingContactInfo, this.paymentMethod);
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            return [4
            /*yield*/
            , paymentLegacyProcessor.processLegacyPayment(this)];

          case 2:
            return [2
            /*return*/
            , _b.sent()];

          case 3:
            e_1 = _b.sent();
            errorHandler = new PaymentErrorHandler_1.PaymentErrorHandler();
            errorHandler.logLegacyProcessingError(e_1, paymentLegacyProcessor, this.session.paymentCommunicator);
            throw e_1;

          case 4:
            _a = this.paymentMethod;

            switch (_a) {
              case Interfaces_1.PaymentMethod.creditCard:
                return [3
                /*break*/
                , 5];

              case Interfaces_1.PaymentMethod.ACH:
                return [3
                /*break*/
                , 9];

              case Interfaces_1.PaymentMethod.notPresent:
                return [3
                /*break*/
                , 13];
            }

            return [3
            /*break*/
            , 14];

          case 5:
            if (!this.creditCardInfo) {
              throw new Errors_1.PaymentValidationError("Credit Card Information is not present", Interfaces_1.PaymentErrorShortCodes.missing_credit_card);
            }

            _b.label = 6;

          case 6:
            _b.trys.push([6, 8,, 9]);

            return [4
            /*yield*/
            , this.session.processCreditCardPayment(this.creditCardInfo, this.billingContactInfo)];

          case 7:
            return [2
            /*return*/
            , _b.sent()];

          case 8:
            e_2 = _b.sent();
            errorHandler = new PaymentErrorHandler_1.PaymentErrorHandler();
            errorHandler.logProcessingError(e_2, this, this.session.paymentCommunicator);
            throw e_2;

          case 9:
            if (!this.achInfo) {
              throw new Errors_1.PaymentValidationError("ACH Information is not present", Interfaces_1.PaymentErrorShortCodes.missing_ach);
            }

            _b.label = 10;

          case 10:
            _b.trys.push([10, 12,, 13]);

            return [4
            /*yield*/
            , this.session.processACHPayment(this.achInfo, this.billingContactInfo)];

          case 11:
            return [2
            /*return*/
            , _b.sent()];

          case 12:
            e_3 = _b.sent();
            errorHandler = new PaymentErrorHandler_1.PaymentErrorHandler();
            errorHandler.logProcessingError(e_3, this, this.session.paymentCommunicator);
            throw e_3;

          case 13:
            {
              throw new Errors_1.PaymentValidationError("Payment Method is not present, make sure to add credit card info or other billing info", Interfaces_1.PaymentErrorShortCodes.missing_payment_method);
            }
            _b.label = 14;

          case 14:
            {
              throw new Errors_1.PaymentClientError("Payment Method is not supported", Interfaces_1.PaymentErrorShortCodes.unsupported_payment_method);
            }
            _b.label = 15;

          case 15:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  PaymentClient.prototype.addSession = function (sessionId, sessionData) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.session = new Session_1.PaymentSession({
          sessionId: sessionId,
          env: this.env
        });
        this.sessionData = sessionData;
        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentClient.prototype.addBillingContactInfo = function (billingContactInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.billingContactInfo = new BillingContact_1.BillingContact(billingContactInfo);
        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentClient.prototype.addCreditCardInfo = function (cardInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.paymentMethod = Interfaces_1.PaymentMethod.creditCard;
        this.creditCardInfo = new BillingMethods_1.BillingMethodCreditCard(cardInfo);
        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentClient.prototype.addACHInfo = function (achInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.paymentMethod = Interfaces_1.PaymentMethod.ACH;
        this.achInfo = new BillingMethods_1.BillingMethodACH(achInfo);
        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentClient.prototype.addECheckInfo = function (eCheckInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.paymentMethod = Interfaces_1.PaymentMethod.eCheck;
        this.eCheckInfo = new BillingMethods_2.BillingMethodECheck(eCheckInfo);
        return [2
        /*return*/
        ];
      });
    });
  };

  PaymentClient.prototype.addEPaperTokenInfo = function (ePaperTokenInfo) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.paymentMethod = Interfaces_1.PaymentMethod.ePaperToken;
        this.ePaperTokenInfo = new BillingMethods_2.BillingMethodEPaperToken(ePaperTokenInfo);
        return [2
        /*return*/
        ];
      });
    });
  };

  return PaymentClient;
}();

exports.PaymentClient = PaymentClient;


// WEBPACK FOOTER //
// ./node_modules/@backoffice/fast-payments-client-js-sdk/build/src/PaymentClient/PaymentClient.js